import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const getListTransactionFile = createAction(Constants.GET_LIST_TRANSACTION_FILE.REQUEST, (filters) => (filters));
export const downloadFile = createAction(Constants.DOWNLOAD_FILE_TRANSACTION.REQUEST, (data) => (data));
export const clearState = createAction(Constants.TRANSACTION_LIST_FILE_CLEAR_STATE,  () => ({}));


